//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionEventGallery",
  components: {
    Gallery: () => import('@/components/common/Gallery'),
    Section: () => import('@/components/common/Section/index'),
  },
  computed: {
    ...mapGetters({
      images: "event/images"
    }),
    gallery() {
      return this.images.map((item, index) => ({
        image: item,
        id: index,
        title: '',
        description: ''
      }))
    },
  }
};
